import {Pipe, PipeTransform} from '@angular/core';
import {ReportExtensions} from '@spa/api';
import {Helper} from '../classes';
import {Language} from '../language';
import {LanguageService} from '../language.service';

@Pipe({
	name: 'formatCurrency'
})
export class FormatCurrencyPipe implements PipeTransform {
	constructor(private languageService: LanguageService) {
	}

	transform(value: number, currency: string, useIso?: boolean, minimumDigits: number = 2, maximumDigits: number = 4): string {
		const maxDigits = Math.max(minimumDigits, maximumDigits);
		let result = ReportExtensions.toDecimalString(
			value,
			maxDigits,
			minimumDigits,
			false);

		if (this.languageService.getCurrentLanguage() === Language.Bulgarian) {
			result = result.replace(/,/g, ' ');
			result = result.replace('.', ',');
		}

		const sign = useIso
			? currency?.toUpperCase()
			: Helper.getCurrencySign(currency);

		if (sign) {
			if (useIso) {
				return `${sign} ${result}`;
			}

			return `${sign}${result}`;
		}

		return result;
	}
}
